{
    "Profile_Dwellings_LossPayee.lossPayee": "Loss Payee",
    "Profile_Dwellings_LossPayee.lossPayeeDetails": "Loss Payee Details",
    "Profile_Dwellings_LossPayee.name": "Name"
}
